var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7803 16.9043V46.0947L31.5 60.6895L6.21973 46.0947V16.9043L31.5 2.30957L56.7803 16.9043Z",
    stroke: "#0F4BFF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8749 24V39H22.0639L15.3672 29.5591H15.2544V39H12V24H14.8561L21.5002 33.4336H21.6355V24H24.8749Z",
    fill: "#0F4BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5637 39V24H37.7554V26.6147H30.8181V30.189H37.0789V32.8037H30.8181V39H27.5637Z",
    fill: "#0F4BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3581 26.6147V24H52V26.6147H47.2875V39H44.0707V26.6147H39.3581Z",
    fill: "#0F4BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.1e8ae7d0213548951a85aa54668b51eb.svg";
export { ForwardRef as ReactComponent };